import { Component, NgZone, OnInit, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ProcessService } from 'src/app/services/process.service';
import { Router } from '@angular/router';
import { Store, select } from '@ngrx/store';
import { UtilsService } from 'src/app/services/utils.service';
import { ProcessCreate } from 'src/app/models/process.model';
import { Jobtype } from 'src/app/models/jobtype.model';
import { Observable } from 'rxjs';
import { fromJobtypes } from 'src/app/reducers/jobtypes.reducer';
import { fromConsultant } from 'src/app/reducers/consultant.reducer';
import { Office } from 'src/app/models/office.model';
import { take } from 'rxjs/operators';
import { setProcesses } from 'src/app/actions/processes.actions';
import { ModalDismissReasons, NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { Consultant } from 'src/app/models/consultant.model';

@Component({
  selector: 'ct-create-process',
  templateUrl: './process-create.component.html',
  styleUrls: ['./process-create.component.scss']
})
export class ProcessCreateComponent implements OnInit {

  @ViewChild('content') content;

  modalRef: NgbModalRef;
  closeResult: string;

  jobtypes$: Observable<Jobtype[]>;

  jobtype: Jobtype = null;
  office: Office;
  consultant: Consultant;
  returnUrl: string;
  jobtypeSelected: Jobtype;

  createProcessForm: FormGroup = this.fb.group({
    office: ['', Validators.required],
    jobtype: [''],
    name: ['', Validators.required],
    description: [''],
  });

  constructor(
    private store: Store,
    private router: Router,
    private fb: FormBuilder,
    public utilsService: UtilsService,
    private processService: ProcessService,
    private ngZone: NgZone,
    private modal: NgbModal,
  ) { }

  ngOnInit(): void {
    this.jobtypes$ = this.store.pipe(select(fromJobtypes.selectBusinessJobtypes));

    this.store.pipe(select(fromConsultant.selectConsultantState)).subscribe(consultant => {
      if (consultant) {
        this.office = consultant.office;
        this.consultant = consultant;
        this.createProcessForm.get('office').setValue(
          consultant.office.name,
        );
      }
    });
  }

  onSubmit() {
    // comprobamos que el formulario es valido y el nombre esta relleno
    const name = this.createProcessForm.get('name').value.trim();

    if (this.createProcessForm.valid && name.length > 0) {
      this.processService.create({
        officeId: this.office.id,
        jobTypeId: this.createProcessForm.get('jobtype').value?.id,
        name,
        description: this.createProcessForm.get('description').value,
        clientId: this.consultant.client.id,
        consultantId: this.consultant.raas.nameid
      } as ProcessCreate).subscribe(candidate => {
        this.utilsService.toast('success', 'ProcessCreated');
        this.utilsService.setLastUrl();
        this.utilsService.goBack();
      }, error => {
        if (error.message === 'ya existe un proceso con ese nombre en esa oficina') {
          this.utilsService.toast('warning', 'ProcessAlreadyExists');
        } else if (error?.cause?.cause !== undefined) {
          switch (error.cause.cause.errorCode) {
            case 4034:
              this.utilsService.toast('error', 'ConsultantCanNotCreate');
              this.router.navigate(['consultant/processes']);
              break;
            default:
              this.utilsService.toast('error', 'CannotCreateProcess', true, this.utilsService.getNacsData({ endpoint: 'POST AppConfig.settings.API + /processes?origin=ct', body: { officeId: this.office.id, jobTypeId: this.createProcessForm.get('jobtype').value?.id, name, description: this.createProcessForm.get('description').value, clientId: this.consultant.client.id, consultantId: this.consultant.raas.nameid }, error: { errorType: error.errorType, errorCode: error.errorCode, message: error.message } }));
              this.router.navigate(['consultant/processes']);
              break;
          }
        } else {
          this.utilsService.toast('error', 'CannotCreateProcess', true, this.utilsService.getNacsData({ endpoint: 'POST AppConfig.settings.API + /processes?origin=ct', body: { officeId: this.office.id, jobTypeId: this.createProcessForm.get('jobtype').value?.id, name, description: this.createProcessForm.get('description').value, clientId: this.consultant.client.id, consultantId: this.consultant.raas.nameid }, error: { errorType: error.errorType, errorCode: error.errorCode, message: error.message } }));
          this.router.navigate(['consultant/processes']);
        }
      });
      localStorage.setItem('lastUrl', this.router.url);
    } else {
      this.utilsService.toast('error', 'WrongFields');
    }
  }

  showModalViewSkills(jobtype: Jobtype) {
    if (!this.modal.hasOpenModals()) {
      this.modalRef = this.modal.open(this.content, { ariaLabelledBy: 'Ver-Competencias', size: 'l' });
      this.modalRef.result.then((result) => {
        this.closeResult = 'Closed with: ' + result;
      }, (reason) => {
        this.closeResult = 'Dismissed ' + this.getDismissReason(reason);
      });
    }
  }

  getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return 'with: ' + reason;
    }
  }
}
